import React, { useState, useEffect, useRef } from 'react';
import { fetchActiveUsers } from '../api/analyticsApi';

const POLL_INTERVAL_MS = 30 * 1000;

const LiveUsersBadge = ({ onClick }) => {
    const [count, setCount] = useState(null);
    const [error, setError] = useState(false);
    const intervalRef = useRef(null);

    const load = async () => {
        try {
            const data = await fetchActiveUsers();
            setCount(data.active_users);
            setError(false);
        } catch {
            setError(true);
        }
    };

    useEffect(() => {
        load();
        intervalRef.current = setInterval(load, POLL_INTERVAL_MS);
        return () => clearInterval(intervalRef.current);
    }, []);

    if (error || count === null) return null;

    const isInteractive = typeof onClick === 'function';
    const baseClasses = 'flex items-center gap-2 px-3 py-2 bg-white rounded-lg border border-gray-200';
    const interactiveClasses = isInteractive
        ? ' hover:bg-gray-50 hover:border-gray-300 transition-colors cursor-pointer'
        : '';

    const content = (
        <>
            <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" />
            </span>
            <span className="text-sm font-semibold text-gray-800">{count}</span>
            <span className="text-xs text-gray-500">live now</span>
        </>
    );

    if (isInteractive) {
        return (
            <button
                type="button"
                onClick={onClick}
                className={baseClasses + interactiveClasses}
                title="View users currently on the Buyer Portal (last 5 min)"
            >
                {content}
            </button>
        );
    }

    return (
        <div
            className={baseClasses}
            title="Users currently navigating the Buyer Portal (last 5 min)"
        >
            {content}
        </div>
    );
};

export default LiveUsersBadge;
